import React from "react";
// import heroBanner from '../img/tim-mossholder-crop-neon_450.jpg';
import heroBanner from '../img/NAS Peer Befriending_450_plus.png';
//Pages
import HeroBannerComp from "../elements/herobanner/HeroBannerComp";
// import "../img/blue.png"; // Import the image for the hero banner
import "../elements/herobanner/herobanner.css"; // Import the CSS file for styling
import { buddyProgram } from "../data/Data";
import { waffled } from "../data/Data";
import { homeSection } from "../data/Data";
import Team from "../elements/team/Team"

export default function Home() {  

  return (
    <>  
      <div className="hero-home">
       <div id="hero">
         {/* <img src={heroBanner} id="hero-banner" className="hero-img"  alt="NAS Peer Befriending Program" /> */}
      <HeroBannerComp className="heroBanner"
        image={heroBanner}
        title="Email us for more information!"
        description="Connect with a peer who has aphasia. Share experiences, resources, and support each other on your journey to better communication."
      />
          </div>
        </div>
  {/* content */}
      <div className="container front">
        <h1>By the people...</h1>
     
{buddyProgram.map(({ id, title, paragraph }) => (
  <div key={id} className="buddy-block">
    <h2>{title || ""}</h2>
    <p>{paragraph}</p>
  </div>
))}


<h2>{waffled.title}</h2>

<div className="buddy-block orange-bg">
  {waffled.block.map((paragraph, idx) => (
    <p key={idx}>{paragraph}</p>
  ))}
</div>



<div className="mission">
  {homeSection.map((block, idx) => {
    if (block.type === "heading") {
      return <h2 key={idx} 
      className={block.className}>
      {block.text}</h2>;
    }

    if (block.type === "paragraph") {
      return (
        <p key={idx} className={block.className || ""}>
          {block.content.map((part, i) =>
            typeof part === "string" || React.isValidElement(part) ? (
              part
            ) : (
              <span key={i} className={part.className}>{part.span}</span>
            )
          )}
        </p>
      );
    }

    if (block.type === "list") {
      return (
        <ul key={idx}>
          {block.items.map((item, i) => (
            <li key={i}>
              <span className={item.className}>
                {item.text}
              </span>
              {item.extra && ` ${item.extra}`}
            </li>
          ))}
        </ul>
      );
    }

    return null;
  })}
</div>

        <Team />
        </div>
      
    </>
  );
};
